export default __webpack_public_path__ + "static/media/whitev3.6abce1bd.png";